import { useCallback } from 'react';
import { useOrderContext } from '@/modules/order/context/OrderContext.tsx';
import {
    AutomaticProductsForm,
    AutomaticProductsFormProps,
} from '@/shared/forms/AutomaticProductsForm/AutomaticProductsForm.tsx';
type UnifiedAutomaticOrderProductSelectionProps = {
    onContinue: () => void;
    onClearSelection: () => void;
};

export function UnifiedAutomaticOrderProductSelection({
    onContinue,
    onClearSelection,
}: UnifiedAutomaticOrderProductSelectionProps) {
    const { isPositionOrder, contextData } = useOrderContext();

    const formData = contextData.getFormData();
    const businessCase = contextData.getBusinessCase();
    const customerInfo = contextData.getCustomerInformation();

    const productType = businessCase?.productType ?? formData.productType;
    const isStandalone = businessCase?.isStandalone ?? formData.isStandalone ?? false;

    const handleSubmit: AutomaticProductsFormProps['onSubmit'] = useCallback(
        ({ values, businessCase, productConfigurations }) => {
            contextData.setFormData(values);
            contextData.setBusinessCase(businessCase);
            contextData.setProductConfigurations(productConfigurations);
            onContinue();
        },
        [contextData, onContinue]
    );

    if (!productType || !customerInfo) {
        return;
    }

    return (
        <AutomaticProductsForm
            scope="ORDER"
            productType={productType}
            isStandalone={isStandalone}
            pricingStrategy={businessCase?.pricingStrategy}
            defaultValues={formData}
            constructionProjectId={customerInfo.constructionProjectId}
            customerOrganizationId={customerInfo.organizationId}
            mode="create"
            onSubmit={handleSubmit}
            onClearSelection={onClearSelection}
            formRules={{
                freightType: { disabled: isPositionOrder },
                disposalPurpose: { disabled: isPositionOrder },
                pricingStrategy: { disabled: isPositionOrder },
                salesMaterialUnit: { disabled: isPositionOrder },
                salesTransportUnit: { disabled: isPositionOrder },
                salesMaterialTaxClassId: { disabled: isPositionOrder },
                salesTransportTaxClassId: { disabled: isPositionOrder },
                isSelectionClearingDisabled: isPositionOrder,
            }}
        />
    );
}
